import { Component } from '@angular/core';

@Component({
    selector: 'ess-header',
    templateUrl: './header.html',
    styleUrls: ['./header.scss']
})
export class SmartHeader {

}